import styled from 'styled-components'

export const ModalContentWrapper = styled.div`
  table .suicr-day-view-header span {
    text-transform: capitalize;
  }
`
